const NON_BREAKING_SPACE = '\u00a0';

export const labelFormatter = (value: number, unit: string): string => {
  return `${value}${NON_BREAKING_SPACE}${unit}`;
};
